module.exports = __webpack_public_path__ + "img/volcano_list.d033f2dc.png";